/** Plateforme Apple (macOS, iPadOS…) — la touche Option envoie `altKey` comme Alt sous Windows/Linux. */
export function isMacPlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
}

/** Libellé du modificateur pour le masque de lecture (bande ±). */
export function readingMaskModifierLabel(): string {
  return isMacPlatform() ? 'Option ⌥' : 'Alt';
}

/** Option/Alt enfoncé sans Cmd/Ctrl (évite les conflits système). */
export function isReadingMaskModifier(e: KeyboardEvent): boolean {
  return e.altKey && !e.metaKey && !e.ctrlKey;
}

/**
 * Touche « augmenter la bande ».
 * Sur macOS, Option + =/+ produit souvent un caractère spécial (≠, ±…) : on s’appuie sur `code`
 * (touche physique) plutôt que sur `key`.
 */
export function isReadingMaskIncreaseKey(e: KeyboardEvent): boolean {
  if (e.code === 'Equal' || e.code === 'NumpadAdd') return true;
  if (e.key === '+' || e.key === '=' || e.key === 'Add') return true;
  return isMacPlatform() && e.key === 'ArrowUp';
}

/** Touche « réduire la bande » (cf. isReadingMaskIncreaseKey pour le détail macOS). */
export function isReadingMaskDecreaseKey(e: KeyboardEvent): boolean {
  if (e.code === 'Minus' || e.code === 'NumpadSubtract') return true;
  if (e.key === '-' || e.key === '_' || e.key === 'Subtract') return true;
  // AZERTY (FR) : « - » est sur la touche ( / - (souvent `Digit8`), pas sur `Minus`
  if (isMacPlatform() && e.code === 'Digit8') return true;
  return isMacPlatform() && e.key === 'ArrowDown';
}
